/* eslint-disable camelcase */
export default class Blanket {
  created_at = '';
  created_by = '';
  blanket_items = [];
  id = 0;
  memo = '';
  partner_id = {};
  status_id = 0;
  due_date = '';
  items_total = 0;
  services_total = 0;
  freight_total = 0;
  subtotal = 0;
  surcharge_total = 0;
  total = 0;
  updated_by = '';
  updated_at = '';
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/Blanket.js